/*global define, console, window, HTMLImageElement, Promise*/

(function (root, factory) {
    "use strict";
    if (typeof define === 'function' && define.amd) {
        define("Awards", ["jquery", "Behaviors"], factory);
    } else {
        root.Awards = factory(root.jQuery, root.Behaviors);
    }
}(this, function ($, Behaviors) {
    "use strict";
    var module = {};

    function Awards() {
        Behaviors.init(Awards, this, arguments);
        this.element = this.$elem[0];

        

        this.initOwlCarousel();

        if(window.innerWidth > 992){
            $(Awards.ELEMENTS.carousel).trigger('destroy.owl.carousel');
        }

        $(Awards.ELEMENTS.awardItem).click(function(){
            var el = $(this).find('.award-description');
            el.fadeToggle("slow");
  
        });
        
    }

    Behaviors.inherit(Awards, Behaviors.Behavior);

    Awards.QUERY = "[data-awards]";

    Awards.ELEMENTS = {
        awardItem: ".Awards .award-item",
        carousel: ".Awards .owl-carousel",
    };

    Awards.prototype.initOwlCarousel = function() {

        if($(Awards.ELEMENTS.carousel).length){

            this.carousel = $(Awards.ELEMENTS.carousel).owlCarousel({
                loop:  true,
                dots: true,
                autoplay: true,
                stagePadding: 30,
                responsive : {
                    0 : {
                        items: 1,
                        slideBy: 1,
                    },
                    768 : {
                        items: 2,
                        slideBy: 1, 
                    },
                    1024 : {
                        items: 3,
                        slideBy: 1, 
                        center: true
                    }
                }
            });

        }
 
    };
    
    Behaviors.register_behavior(Awards);

    module.Awards = Awards;

    window.addEventListener("resize", function () {
        
        if(this.innerWidth > 992){
            if( $(Awards.ELEMENTS.carousel).length )
                Awards.prototype.carousel.trigger('destroy.owl.carousel');

        }else{
            if( $(Awards.ELEMENTS.carousel).length )
                Awards.prototype.initOwlCarousel();
        }
    });

    return module;
}));
